<template>
  <transition name="cookie-transition">
    <div v-if="showCookie" class="cookie-popup">
      <div class="cookie-popup__wrapper">
        <a class="vfm__close" @click="closeCookie"><Icon icon="close" /></a>
        <div class="cookie-popup__content">
          Используя данный сайт, вы даёте согласие на использование файлов
          cookie, помогающих нам сделать его удобнее для вас.
          <router-link class="cookie-popup__link" to="/policy" target="_blank"
            >Подробнее</router-link
          >
        </div>
        <button class="btn btn-default btn-small" @click="closeCookie">
          Хорошо не показывать больше
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    agreement: {
      type: [Object, String],
      default: "/",
    },
  },
  data() {
    return {
      showCookie: false,
      broadcastChannel: null,
    };
  },
  mounted() {
    this.broadcastChannel = new BroadcastChannel("cookie_consent");

    this.broadcastChannel.addEventListener("message", (event) => {
      if (event.data.action === "cookie_closed") {
        this.showCookie = false;
      }
      if (event.data.action === "cookie_check") {
        this.broadcastChannel.postMessage({
          action: "cookie_status",
          status: localStorage.getItem("cookieApproved") === "true",
        });
      }
      if (event.data.action === "cookie_status" && event.data.status) {
        this.showCookie = false;
      }
    });

    this.checkCookieStatus();

    this.broadcastChannel.postMessage({ action: "cookie_check" });
  },
  beforeUnmount() {
    if (this.broadcastChannel) {
      this.broadcastChannel.close();
    }
  },
  methods: {
    checkCookieStatus() {
      const cookieApproved = localStorage.getItem("cookieApproved");
      if (cookieApproved !== "true") {
        setTimeout(() => {
          this.showCookie = true;
        }, 1500);
      } else {
        this.showCookie = false;
      }
    },
    closeCookie() {
      localStorage.setItem("cookieApproved", "true");
      this.showCookie = false;

      if (this.broadcastChannel) {
        this.broadcastChannel.postMessage({ action: "cookie_closed" });
      }
    },
  },
};
</script>

<style scoped>
.cookie-transition-enter-active,
.cookie-transition-leave-active {
  transition: all 0.3s ease;
}

.cookie-transition-enter-from,
.cookie-transition-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.cookie-popup {
  position: fixed;
  right: 15px;
  bottom: 50px;
  z-index: 5;
  pointer-events: none;
  font-family: "Mabry";
}

.cookie-popup__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 19px;
  box-sizing: border-box;
  width: 310px;
  min-height: 142px;
  padding: 30px 48px;
  color: #000000;
  background: #ffffff;
  border-radius: 15px;
  pointer-events: all;
}

.cookie-popup__content {
  max-width: 347px;
  font-size: 10px;
  font-weight: 400;
  text-align: center;
  line-height: 100%;
  color: #3f4440;
}

.cookie-popup__link {
  color: #c56046;
  text-decoration: none;
}

.btn-small {
  font-size: 10px;
  width: 100%;
}

.vfm__close {
  top: 14px !important;
  right: 14px;
  width: 10px;
  height: 10px;
  cursor: pointer;
}

@media (max-width: 575px) {
  .cookie-popup {
    right: auto;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
